module.exports = __webpack_public_path__ + "img/cloudBeike.83935a44.png";